// ============================================
// UTILS - Clases de badge por estado, compartidas entre las pantallas de Caja 360
// ============================================
import type { TurnoCajaEstado } from '@almacenes/core';

// Cubre los 3 estados reales de MovimientoCajaEstado. MiCajaPage y
// TurnoDetalleModal solo llegan a mostrar PENDIENTE/APROBADO (movimientos del
// propio turno); CajaAdministracionPage además muestra RECHAZADO en la tab de
// resueltos. El caso default no ocurre con datos reales, es solo defensivo.
export const badgeEstadoMovimiento = (estado: string) => {
  switch (estado) {
    case 'APROBADO':
      return 'bg-green-100 text-green-800';
    case 'PENDIENTE':
      return 'bg-yellow-100 text-yellow-800';
    case 'RECHAZADO':
      return 'bg-red-100 text-red-700';
    default:
      return 'bg-gray-100 text-gray-500';
  }
};

export const badgeEstadoTurno = (estado: TurnoCajaEstado) => {
  switch (estado) {
    case 'ABIERTO':
      return 'bg-green-100 text-green-800';
    case 'CERRADO_FORZADO':
      return 'bg-orange-100 text-orange-800';
    default:
      return 'bg-gray-100 text-gray-700';
  }
};
